import { render, staticRenderFns } from "./Results-management.vue?vue&type=template&id=0805e6c2&scoped=true&"
import script from "./Results-management.vue?vue&type=script&lang=js&"
export * from "./Results-management.vue?vue&type=script&lang=js&"
import style0 from "./Results-management.vue?vue&type=style&index=0&id=0805e6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805e6c2",
  null
  
)

export default component.exports